import { createSlice } from '@reduxjs/toolkit';

import { ServiceConstants } from 'constant';
import { ServiceModel } from 'types';

const { REQUEST_ERROR, REQUEST_PENDING, REQUEST_SUCCESS } = ServiceConstants;

export const serviceSlice = createSlice({
  name: 'service',
  initialState: {
    object: {} as any,
  },
  reducers: {
    start: (state, action) => {
      const id = action.payload;
      state.object[id] = { status: REQUEST_PENDING };
    },
    end: (state, action) => {
      const { id, data }: ServiceModel = action.payload;
      state.object[id] = { status: REQUEST_SUCCESS, data: data };
    },
    error: (state, action) => {
      const { id, data }: ServiceModel = action.payload;
      state.object[id] = { status: REQUEST_ERROR, data: data };
    },
    reset: (state, action) => {
      const id = action.payload;
      delete state.object[id];
    },
  },
});

export const { end, error, reset, start } = serviceSlice.actions;
export default serviceSlice.reducer;
